import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

function HomePage() {

  return (
    <div 
      className="homepage-container"
      style={{
        backgroundImage: `url('/talentvibe-workflow-bg.png')`,
        backgroundSize: 'contain', // Changed from 'cover' to 'contain' to show entire image without cropping
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundColor: '#0c001f'
      }}
    >
      <div className="glass-container homepage-content">
        <h1 className="homepage-title">
          Hire Smarter, Not Harder.
        </h1>
        <p className="homepage-subtitle">
          Welcome to <strong>TalentVibe</strong>. Our AI-powered platform intelligently analyzes and ranks résumés based on your job descriptions, helping you find the perfect candidate in record time.
        </p>
        <Link to="/jobs" className="cta-button">
          Get Started Now
        </Link>
      </div>
    </div>
  );
}

export default HomePage; 